exports = module.exports = require("../../../../../../.config/yarn/global/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".text-input textarea[data-v-d4d3fd5c]{border:0;font-size:18px;padding:20px 30px;background-color:transparent;color:var(--brainstorm-fg);resize:none;border-radius:0 0 10px 10px;width:100%;outline:none}", ""]);

// exports
